var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 92,
    viewBox: "0 0 181 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M180.208 -53.92V-18.88L171.088 -18.4C160.528 -18.4 153.008 -15.84 148.528 -10.72C144.368 -5.60002 142.288 1.27999 142.288 9.91999V26.72H173.008V91.52H105.328V7.03997C105.328 -15.68 110.448 -31.36 120.688 -40C131.248 -48.96 145.168 -53.6 162.448 -53.92H180.208ZM75.5675 -53.92V-18.88L65.9675 -18.4C55.7275 -18.4 48.3675 -15.84 43.8875 -10.72C39.7275 -5.60002 37.6475 1.27999 37.6475 9.91999V26.72H68.3675V91.52H0.6875V7.03997C0.6875 -15.68 5.8075 -31.36 16.0475 -40C26.2875 -48.96 40.2075 -53.6 57.8075 -53.92H75.5675Z",
    fill: "#F1F1F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTop);
export default __webpack_public_path__ + "static/media/top.5ea24eea045392ec8d381b16b82ee54f.svg";
export { ForwardRef as ReactComponent };